import { Store } from 'utils';

class PavilionStore extends Store {

	getInitialState() {
		return {
			pavilions: [],
			id: null,
            error: false,
			data: null,
			logoUrl: null,
			loaderUrl: null,
			frontFairLogo: null,
			fastApplySiteLogoUrl: null,
			title: '',
			slugs: [],
			menu: false,
			tosLink: null,
			translations: [],
			startsAt: null,
			endsAt: null,
		}
	}

	isMenuVisible() {
		return this.getState().menu;
	}

	onMenuVisibilityChanged(state, data) {
		state.menu = data.visible;
	}

	onJobsChanged(state) {
		state.menu = false;
	}

	onPavilionsChanged(state, data) {
        state.pavilions = data.pavilions;

		var slugs = [];

		data.pavilions.forEach(function(item) {
			slugs[item.slug] = item.id;
		});

		state.slugs = slugs;
		state.data = data;
		state.logoUrl = data.logoUrl;
		state.loaderUrl = data.loaderUrl;
		state.id = data.id;
		state.title = data.name;
        state.error = false;
		state.translations = data.translations;
		state.frontFairLogo = data.frontFairLogo;
		state.fastApplySiteLogoUrl = data.fastApplySiteLogoUrl;
		state.tosLink = data.tosLink;
		state.startsAt = data.startsAt;
		state.endsAt = data.endsAt;
	}

	onResetFrontFairLogoUrl(state, data)
	{
		state.frontFairLogo = data.url;
	}

	onFairLogoUrlChanged(state, data)
	{
		state.logoUrl = data.logoUrl;
	}

	getTranslations() {
		return this.getState().translations;
	}

	getPavilions() {
		return this.getState().pavilions;
	}

	getFairId() {
		return this.getState().id;
	}

	getFairDomain()
	{
		return this.getState().data.domain;
	}

	getFairLogoUrl()
	{
		return this.getState().logoUrl;
	}

	getFairData()
	{
		return this.getState().data;
	}

	getBackgroundUrl() {
		var data = this.getState().data;

		if(data) {
			return data.backgroundURL;
		} else {
			return null;
		}

	}

	getPavilionId(slug) {
		return this.getState().slugs[slug];
	}

	getFairTitle(pages) {
		var title = this.getState().title;

		if(title) {
			var parts = [title].concat(pages);
			return parts.join(' - ');
		} else {
			return pages.join(' - ');
		}
	}

    onError(state) {
        state.error = true;
    }
}

const store = new PavilionStore();
export default store;



// WEBPACK FOOTER //
// ./src/modules/model/fairstore.js